// extracted by mini-css-extract-plugin
export var wordContainer = "_oi-0";